<script>
    import I18n from '@js/modules/translations';
    import Computation from '@js/modules/computation';

    // suggestions: null = not queried yet, [] = queried empty, [...] = results.
    // available: the tool is shown as a capability; enabled: a route exists so it can run.
    const {suggestions = null, loading = false, onSuggest, onAdd, available = false, enabled = false} = $props();

    // The trigger stays available so the user can re-run it after editing the route (not one-shot).
    const _triggerLabel = $derived(
        loading
            ? I18n.t('js.maps.poi_suggestions.searching')
            : (suggestions === null ? I18n.t('js.maps.poi_suggestions.suggest') : I18n.t('js.maps.poi_suggestions.search_again'))
    );
</script>

{#if available}
    <div class="map-poi-suggestions" class:map-tool-disabled={!enabled}>
        <button class="poi-suggestions-trigger"
                type="button"
                disabled={!enabled || loading}
                onclick={onSuggest}>
            {_triggerLabel}
        </button>

        {#if !enabled}
            <p class="poi-suggestions-hint">
                {I18n.t('js.maps.poi_suggestions.needs_route')}
            </p>
        {:else if suggestions === null}
            <p class="poi-suggestions-hint">
                {I18n.t('js.maps.poi_suggestions.explanation')}
            </p>
        {:else if suggestions.length === 0}
            <p class="poi-suggestions-empty">
                {I18n.t('js.maps.poi_suggestions.empty')}
            </p>
        {:else}
            <ul class="poi-suggestions-list">
                {#each suggestions as suggestion (`${suggestion.latitude},${suggestion.longitude}`)}
                    <li class="poi-suggestion">
                        <span class="poi-suggestion-kind">
                            {I18n.t(`js.ride.form.pois.waypoint_kind.${suggestion.waypointKind}`)}
                        </span>
                        <span class="poi-suggestion-name">
                            {suggestion.name || Computation.formatDistance(suggestion.distanceAlong, {smartUnit: true})}
                        </span>
                        <button class="poi-suggestion-add"
                                type="button"
                                title={I18n.t('js.maps.poi_suggestions.add')}
                                aria-label={I18n.t('js.maps.poi_suggestions.add')}
                                onclick={() => onAdd(suggestion)}>
                            +
                        </button>
                    </li>
                {/each}
            </ul>
        {/if}
    </div>
{/if}
